import api from './client';
import type {
  OrgCreate,
  OrgUpdate,
  OrgResponse,
  ListParams,
} from './types';

export const organizationsApi = {
  /**
   * List all organizations
   * @param params - Query parameters (limit)
   */
  list: async (params?: ListParams): Promise<OrgResponse[]> => {
    const { data } = await api.get('/organizations', { params });
    return data;
  },

  /**
   * Get a specific organization by ID
   * @param orgId - Organization ID
   */
  get: async (orgId: string): Promise<OrgResponse> => {
    const { data } = await api.get(`/organizations/${orgId}`);
    return data;
  },

  /**
   * Create a new organization
   * @param org - Organization data
   */
  create: async (org: OrgCreate): Promise<OrgResponse> => {
    const { data } = await api.post('/organizations', org);
    return data;
  },

  /**
   * Update an existing organization
   * @param orgId - Organization ID
   * @param updates - Fields to update
   */
  update: async (orgId: string, updates: OrgUpdate): Promise<OrgResponse> => {
    const { data } = await api.patch(`/organizations/${orgId}`, updates);
    return data;
  },

  /**
   * Delete an organization
   * @param orgId - Organization ID
   */
  delete: async (orgId: string): Promise<void> => {
    await api.delete(`/organizations/${orgId}`);
  },

  /**
   * Upload logo for an organization
   * @param orgId - Organization ID
   * @param file - Image file to upload
   * @returns Object with logo_url and message
   */
  uploadLogo: async (orgId: string, file: File): Promise<{ logo_url: string; message: string }> => {
    const formData = new FormData();
    formData.append('file', file);

    const { data } = await api.post(`/organizations/${orgId}/logo`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return data;
  },
};
